import type { AboutYageoGroupOverviewContent } from '../types/AboutYageoGroupOverviewContent';

export function createAboutYageoGroupOverviewContentPlaceholder(): AboutYageoGroupOverviewContent {
    return {
        pageTitle: { kind: 'plainText', key: '', content: '' },
        pageSubtitle: { kind: 'plainMultilineText', key: '', content: '' },
        pageTitleBackgroundImage: { kind: 'image', key: '', imageUrl: '' },
        Overview: {
            title: { kind: 'plainText', key: '', content: '' },
            mainText: { kind: 'richText', key: '', content: '', sanitizedContent: '' },
            mainImage: { kind: 'image', key: '', imageUrl: '' },
            links: { kind: 'linkCollection', key: '', links: [] },
            Brands: {
                title: { kind: 'plainText', key: '', content: '' },
                brands: { kind: 'brandCardCollection', key: '', entries: [] },
            },
        },
    };
}
